<template>
	<div class="patient-view report">
		<FacesheetCard :patient="patient"></FacesheetCard>
	</div>
</template>

<script>
import PatientView from '..'
import { mapState, mapActions, mapGetters } from 'vuex'

const CHART_API = 'https://' + (process.env.NODE_ENV === 'dev' ? 'dev.' : '') + 'api.doctorplan.com/chart/'

export default {
	name: 'patient-facesheet',
	extends: PatientView,

	computed: {
		...mapGetters('content', [
			'getContent'
		]),
		patientCondition() {
			var profile = this.getContent('profile', this.patient.profile[0])
			if (profile)
				return profile.title
		},
		src() {
			return CHART_API + '?patient=' + this.patient.id + '&article=false&condition=' + this.patientCondition
		}
	}
}
</script>

<style lang="scss" scoped>
iframe {
	width: 100%;
	height: 800px;
	border: none;
}
.el-card {

}
</style>
